<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CgqFeY/tc-custom/9781524881412.jpg?1708400496548" alt="This image is the cover for the book Forest + Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forest + Home
      </h1>
      <p class="bookDescription body article font2">
        <i>Forest + Home</i> connects you with nature through your kitchen, no matter the size or location. This is a book that inspires and ignites the palette while nourishing the soul; it shares food that both feeds and heals the body. Discover the world of plants through food with cook and certified herbalist, Spencre McGowan, author of <i>Blotto Botany: A Lesson in Healing Cordials and Plant Magic</i>. Organized by season, the recipes are designed to meet the natural move­ment of time and the world we inhabit. They include:Nettle Pasta with special healing qualitiesRose Petal Lemonade with the benefits of a herbal punchRoasted Asparagus with Chamomile and Ghee to soothe your nervesNo-Bake Peanut Butter–Reishi Cookies incorporates healing mushroomsDandelion Pesto helps get your digestive groove onLemon Balm Mojito for a refreshing way to chill out<br/>Through personal stories and photography, explore the icy mountains of Montana and the wild seashores of Maine and Nantucket. With a focus on simplicity, no dish in this book requires one to be an experienced chef, possess a knowl­edge of medicinal herbalism, or own expensive kitchen tools.<br/><br/>In addition to a foreword by bestselling author Hilarie Burton Morgan, the book includes glossaries of kitchen and medicinal herbs; an exploration of adaptogenic herbs and edible flowers; and information on sourcing, growing, drying, and storing your own herbs. <i>Forest + Home</i> is a love letter to our environment, encour­aging us to reflect on the things we feel when we are connected to nature and the things we take home with us.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Spencre McGowan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e445484e